import { render, staticRenderFns } from "./peiceAlert.vue?vue&type=template&id=3d7589e8&scoped=true&"
import script from "./peiceAlert.vue?vue&type=script&lang=js&"
export * from "./peiceAlert.vue?vue&type=script&lang=js&"
import style0 from "./peiceAlert.vue?vue&type=style&index=0&id=3d7589e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7589e8",
  null
  
)

export default component.exports